import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { forEach } from 'lodash';

import { Breadcrumb } from './breadcrumbs';
import { Enums } from '../../configs/Enums';
import { BreadcrumbsService } from './breadcrumbs.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false,
})
export class BreadcrumbsComponent implements OnInit {
  public currentBreadcrumbs: Breadcrumb[];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.breadcrumbsState.subscribe((breadcrumbsState) => {
      this.currentBreadcrumbs = breadcrumbsState;
      this.makeBreadcrumbsTitle(this.currentBreadcrumbs);
    });
  }

  private makeBreadcrumbsTitle(breadcrumbs: Breadcrumb[]) {
    let defaultTitle = Enums.projectName;
    let title = '';

    if (breadcrumbs && breadcrumbs.length) {
      forEach(breadcrumbs, (bredcrumb, index) => {
        title += bredcrumb.text;
        title += index < breadcrumbs.length - 1 ? ' : ' : '';
      });

      document.title = title;
    } else {
      document.title = defaultTitle;
    }
  }
}
